import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type {
  CreateVehicleModelPayload,
  UpdateVehicleModelPayload,
  VehicleModel,
} from "#/types/vehicle-model";

export const vehicleModelApi = {
  create: (body: CreateVehicleModelPayload): Promise<ApiResponse<VehicleModel>> =>
    api.post("/vehicle-model", body),
  getAll: (
    params?: BaseFilterParams
  ): Promise<ApiResponse<Paginated<VehicleModel[]>>> =>
    api.get("/vehicle-model", { params }),
  getById: (id: number): Promise<ApiResponse<VehicleModel>> =>
    api.get(`/vehicle-model/${id}`),
  update: (
    id: number,
    body: Partial<UpdateVehicleModelPayload>
  ): Promise<ApiResponse<VehicleModel>> => api.patch(`/vehicle-model/${id}`, body),
  delete: (id: number): Promise<ApiResponse<void>> =>
    api.delete(`/vehicle-model/${id}`),
};
